/**
 * Movimento das asas, gerado dos `wings.swf` do legado (34 asas). O exportador de atlas junta os quadros de cada símbolo numa tela que é a
 * união de todos os quadros da animação; o ponto de registro de cada quadro é o canto dessa união (`t`) mais o deslocamento do quadro no atlas.
 * Medidas em px, no sistema do símbolo; matrizes `[a, b, c, d, tx, ty]` (escala, giro e posição) como no SWF.
 *
 * - `s`: o símbolo `wing_show` (boneco em pé). `t` e `z` são o canto e o tamanho da tela da união; `p` lista as animações dentro dele (`n` é o nome
 *   no atlas, `f` o número de quadros, `m` a matriz em que ela entra no símbolo e `t` o canto da tela dela). A asa direita costuma ser a esquerda espelhada.
 * - `g`: a asa na partida, `l` (esquerda, atrás do corpo) e `r` (direita, à frente). `n` é o quadro estático do atlas (`<n>/1` espera, `<n>/2` tiro),
 *   `t` o canto da tela dele e `v` o clipe que bate (`n`, `f` quadros, `t`, `m` = matriz do clipe na espera e no tiro).
 */
export interface WingMotionSprite {
  n: string;
  f: number;
  m: readonly [number, number, number, number, number, number];
  t: readonly [number, number];
}
export interface WingMotionSide {
  n: string;
  t: readonly [number, number];
  v?: { n: string; f: number; t: readonly [number, number]; m: readonly (readonly [number, number, number, number, number, number])[] };
}
export interface WingMotion {
  s?: { t: readonly [number, number]; z: readonly [number, number]; p: readonly WingMotionSprite[] };
  g?: { l: WingMotionSide; r: WingMotionSide };
}

export const WING_MOTION: Readonly<Record<string, WingMotion>> = {
 wing002: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,101.55],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-41.55,14.34],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[0.98,0.21,-0.21,0.98,-8.9,15.1],[0.96,-0.29,0.29,0.96,-41.55,42.25]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-43.7,15.67],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.04,-0.04,1,-16.3,29.45],[0.82,-0.57,0.57,0.82,-43.7,70.7]]
    }
   }
  }
 },
 wing003: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,101.55],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-41.55,14.34],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[0.98,0.21,-0.21,0.98,-8.9,15.1],[0.96,-0.29,0.29,0.96,-41.55,42.25]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-43.7,15.67],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.04,-0.04,1,-16.3,29.45],[0.82,-0.57,0.57,0.82,-43.7,70.7]]
    }
   }
  }
 },
 wing004: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,101.55],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-41.55,14.34],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[0.98,0.21,-0.21,0.98,-8.9,15.1],[0.96,-0.29,0.29,0.96,-41.55,42.25]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-43.7,15.67],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.04,-0.04,1,-16.3,29.45],[0.82,-0.57,0.57,0.82,-43.7,70.7]]
    }
   }
  }
 },
 wing005: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,101.55],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-41.55,14.34],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[0.98,0.21,-0.21,0.98,-8.9,15.1],[0.96,-0.29,0.29,0.96,-41.55,42.25]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-43.7,15.67],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.04,-0.04,1,-16.3,29.45],[0.82,-0.57,0.57,0.82,-43.7,70.7]]
    }
   }
  }
 },
 wing006: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,73.58],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-26.45,25.26],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[1,-0.05,0.05,1,-4.1,37.9],[0.86,-0.51,0.51,0.86,-26.45,64.75]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-26.9,25.86],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.03,-0.03,1,0.55,36.8],[0.82,-0.57,0.57,0.82,-26.9,70]]
    }
   }
  }
 },
 wing007: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,73.58],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-26.45,25.26],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[1,-0.05,0.05,1,-4.1,37.9],[0.86,-0.51,0.51,0.86,-26.45,64.75]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-26.9,25.86],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.03,-0.03,1,0.55,36.8],[0.82,-0.57,0.57,0.82,-26.9,70]]
    }
   }
  }
 },
 wing008: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,73.58],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-26.45,25.26],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[1,-0.05,0.05,1,-4.1,37.9],[0.86,-0.51,0.51,0.86,-26.45,64.75]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-26.9,25.86],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.03,-0.03,1,0.55,36.8],[0.82,-0.57,0.57,0.82,-26.9,70]]
    }
   }
  }
 },
 wing009: {
  s: {
   t: [-22.33,55.1],
   z: [161.38,73.58],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,49.95,111.05],
     t: [-6.13,-55.85]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,48.95,110.95],
     t: [-6.13,-55.85]
    }]
  },
  g: {
   l: {
    n: "wings_fla.gameWingIn_2",
    t: [-26.45,25.26],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,0],
     m: [[1,-0.05,0.05,1,-4.1,37.9],[0.86,-0.51,0.51,0.86,-26.45,64.75]]
    }
   },
   r: {
    n: "wings_fla.gameWingOut_4",
    t: [-26.9,25.86],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[1,0.03,-0.03,1,0.55,36.8],[0.82,-0.57,0.57,0.82,-26.9,70]]
    }
   }
  }
 },
 wing018: {
  s: {
   t: [-22.87,12.95],
   z: [156.13,137.81],
   p: [
    {
     n: "sprite32",
     f: 20,
     m: [0.71,0,0,0.84,50.05,128.95],
     t: [-12.25,-138.55]
    },
    {
     n: "sprite32",
     f: 20,
     m: [-0.58,0,0,0.84,44.35,129.05],
     t: [-12.25,-138.55]
    }]
  },
  g: {
   l: {
    n: "sprite42",
    t: [1.58,30.64],
    v: {
     n: "sprite38",
     f: 19,
     t: [49.28,-29.93],
     m: [[0.63,-0.49,0.49,0.63,-5.75,105.6],[-0.04,-0.8,0.8,-0.04,31.6,131.55]]
    }
   },
   r: {
    n: "sprite60",
    t: [-27.64,-4.5],
    v: {
     n: "sprite58",
     f: 19,
     t: [26.61,-66.51],
     m: [[0.57,-0.56,0.56,0.57,-5.5,111.8],[-0.25,-0.76,0.76,-0.25,46.6,131.5]]
    }
   }
  }
 },
 wing019: {
  s: {
   t: [-43.49,41.55],
   z: [198.19,90.48],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-9.17,-59.4]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,44.15,100.95],
     t: [-9.17,-59.4]
    }]
  },
  g: {
   l: {
    n: "sprite18",
    t: [-7.4,30.78],
    v: {
     n: "sprite17",
     f: 19,
     t: [0,-4.25],
     m: [[1,-0.05,0.05,1,2.3,48.7],[0.51,-0.86,0.86,0.51,-3.75,99]]
    }
   },
   r: {
    n: "sprite32",
    t: [-14.47,26.33],
    v: {
     n: "sprite31",
     f: 19,
     t: [5.25,-1.5],
     m: [[1,0.03,-0.03,1,0.8,39.05],[0.58,-0.81,0.81,0.58,-16.3,94.1]]
    }
   }
  }
 },
 wing020: {
  s: {
   t: [-28.45,15.55],
   z: [164.35,137.25],
   p: [
    {
     n: "sprite19",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-3.1,-85.4]
    },
    {
     n: "sprite19",
     f: 20,
     m: [-0.8,0,0,1,44.15,100.95],
     t: [-3.1,-85.4]
    }]
  },
  g: {
   l: {
    n: "sprite34",
    t: [-15.75,26.2],
    v: {
     n: "sprite33",
     f: 19,
     t: [0,0],
     m: [[0.73,0.32,-0.32,0.73,22,26.2],[0.68,-0.41,0.46,0.77,-15.75,61.65]]
    }
   },
   r: {
    n: "sprite48",
    t: [-11.15,26.65],
    v: {
     n: "sprite47",
     f: 19,
     t: [0,0],
     m: [[0.7,0.39,-0.39,0.7,22.9,26.65],[0.65,-0.46,0.46,0.65,-11.15,73.45]]
    }
   }
  }
 },
 wing021: {
  s: {
   t: [-28.45,16.55],
   z: [164.35,136.25],
   p: [
    {
     n: "sprite19",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-3.1,-85.4]
    },
    {
     n: "sprite19",
     f: 20,
     m: [-0.8,0,0,1,44.15,101.95],
     t: [-3.1,-85.4]
    }]
  },
  g: {
   l: {
    n: "sprite34",
    t: [-15.75,26.2],
    v: {
     n: "sprite33",
     f: 19,
     t: [0,0],
     m: [[0.73,0.32,-0.32,0.73,22,26.2],[0.68,-0.41,0.46,0.77,-15.75,61.65]]
    }
   },
   r: {
    n: "sprite48",
    t: [-10.9,35.75],
    v: {
     n: "sprite47",
     f: 19,
     t: [0,0],
     m: [[0.78,0.17,-0.17,0.78,8.15,35.75],[0.65,-0.46,0.46,0.65,-10.9,73.2]]
    }
   }
  }
 },
 wing022: {
  s: {
   t: [-28.45,15.55],
   z: [164.35,137.25],
   p: [
    {
     n: "sprite19",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-3.1,-85.4]
    },
    {
     n: "sprite19",
     f: 20,
     m: [-0.8,0,0,1,44.15,100.95],
     t: [-3.1,-85.4]
    }]
  },
  g: {
   l: {
    n: "sprite34",
    t: [-15.75,26.2],
    v: {
     n: "sprite33",
     f: 19,
     t: [0,0],
     m: [[0.73,0.32,-0.32,0.73,22,26.2],[0.68,-0.41,0.46,0.77,-15.75,61.65]]
    }
   },
   r: {
    n: "sprite48",
    t: [-10.9,35.75],
    v: {
     n: "sprite47",
     f: 19,
     t: [0,0],
     m: [[0.78,0.17,-0.17,0.78,8.15,35.75],[0.65,-0.46,0.46,0.65,-10.9,73.2]]
    }
   }
  }
 },
 wing023: {
  s: {
   t: [-28.45,15.55],
   z: [164.35,137.25],
   p: [
    {
     n: "sprite19",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-3.1,-85.4]
    },
    {
     n: "sprite19",
     f: 20,
     m: [-0.8,0,0,1,44.15,100.95],
     t: [-3.1,-85.4]
    }]
  },
  g: {
   l: {
    n: "sprite34",
    t: [-15.75,26.2],
    v: {
     n: "sprite33",
     f: 19,
     t: [0,0],
     m: [[0.73,0.32,-0.32,0.73,22,26.2],[0.68,-0.41,0.46,0.77,-15.75,61.65]]
    }
   },
   r: {
    n: "sprite48",
    t: [-10.9,35.75],
    v: {
     n: "sprite47",
     f: 19,
     t: [0,0],
     m: [[0.78,0.17,-0.17,0.78,8.15,35.75],[0.65,-0.46,0.46,0.65,-10.9,73.2]]
    }
   }
  }
 },
 wing024: {
  s: {
   t: [-31.2,-9.15],
   z: [168.23,156.69],
   p: [
    {
     n: "sprite9",
     f: 20,
     m: [-1.05,0,0,1.08,49.95,96.75],
     t: [0.28,-97.78]
    },
    {
     n: "sprite9",
     f: 20,
     m: [1.25,0,0,1.08,40.7,96.75],
     t: [0.28,-97.78]
    }]
  },
  g: {
   l: {
    n: "sprite16",
    t: [10.13,35.62],
    v: {
     n: "sprite13",
     f: 19,
     t: [21.05,3.43],
     m: [[0.59,0.81,-0.61,0.74,36.5,16],[0.99,-0.12,0,1.01,-7.4,51]]
    }
   },
   r: {
    n: "sprite22",
    t: [-19.9,8.63],
    v: {
     n: "sprite19",
     f: 19,
     t: [-5.67,-16.15],
     m: [[0.88,0.47,-0.47,0.88,31.05,25.5],[0.93,-0.36,0.36,0.93,-10.7,56.1]]
    }
   }
  }
 },
 wing025: {
  s: {
   t: [-28.3,-0.64],
   z: [159.88,152.85],
   p: [
    {
     n: "sprite11",
     f: 20,
     m: [-1.05,0,0,1.08,49.95,96.75],
     t: [-4.52,-89.93]
    },
    {
     n: "sprite11",
     f: 20,
     m: [1.25,0,0,1.08,38.7,96.75],
     t: [-4.52,-89.93]
    }]
  },
  g: {
   l: {
    n: "sprite17",
    t: [13.5,37.97],
    v: {
     n: "sprite15",
     f: 19,
     t: [22.43,5.1],
     m: [[0.59,0.81,-0.61,0.74,36.5,16],[0.99,-0.12,0,1.01,-7.4,51]]
    }
   },
   r: {
    n: "sprite28",
    t: [-18.11,10.44],
    v: {
     n: "sprite23",
     f: 19,
     t: [-3.85,-15.08],
     m: [[0.88,0.47,-0.47,0.88,31.05,25.5],[0.93,-0.36,0.36,0.93,-10.7,56.1]]
    }
   }
  }
 },
 wing026: {
  s: {
   t: [-31.2,-9.15],
   z: [168.23,157.74],
   p: [
    {
     n: "sprite9",
     f: 20,
     m: [-1.05,0,0,1.08,49.95,96.75],
     t: [1.31,-97.78]
    },
    {
     n: "sprite9",
     f: 20,
     m: [1.25,0,0,1.08,40.7,96.75],
     t: [1.31,-97.78]
    }]
  },
  g: {
   l: {
    n: "sprite18",
    t: [-9.54,12.85],
    v: {
     n: "sprite13",
     f: 19,
     t: [26.2,-7.6],
     m: [[0.59,0.81,-0.61,0.74,36.5,16],[0.99,-0.12,0,1.01,-7.4,51]]
    }
   },
   r: {
    n: "sprite26",
    t: [-19.9,8.63],
    v: {
     n: "sprite23",
     f: 19,
     t: [-5.67,-16.15],
     m: [[0.88,0.47,-0.47,0.88,31.05,25.5],[0.93,-0.36,0.36,0.93,-10.7,56.1]]
    }
   }
  }
 },
 wing027: {
  s: {
   t: [-15.66,56.48],
   z: [132.81,102.83],
   p: [
    {
     n: "sprite4",
     f: 20,
     m: [-0.8,0,0,1,44.15,98.7],
     t: [-8.95,-42.22]
    },
    {
     n: "sprite4",
     f: 20,
     m: [1,0,0,1,42.4,100.5],
     t: [-8.95,-42.22]
    }]
  },
  g: {
   l: {
    n: "sprite19",
    t: [-29.56,-4.9],
    v: {
     n: "sprite18",
     f: 19,
     t: [-9.6,-22.55],
     m: [[0.66,0.75,-0.75,0.66,34.45,17.15],[0.99,0.12,-0.12,0.99,-3.85,39.95]]
    }
   },
   r: {
    n: "sprite33",
    t: [-20.12,12.4],
    v: {
     n: "sprite32",
     f: 19,
     t: [-4.15,-9.8],
     m: [[0.96,0.27,-0.27,0.96,18,28.7],[0.87,-0.5,0.5,0.87,-11.65,63.45]]
    }
   }
  }
 },
 wing028: {
  s: {
   t: [-15.66,56.23],
   z: [132.81,102.83],
   p: [
    {
     n: "sprite4",
     f: 20,
     m: [-0.8,0,0,1,44.15,98.45],
     t: [-8.95,-42.22]
    },
    {
     n: "sprite4",
     f: 20,
     m: [1,0,0,1,42.4,100.25],
     t: [-8.95,-42.22]
    }]
  },
  g: {
   l: {
    n: "sprite19",
    t: [-29.56,-4.9],
    v: {
     n: "sprite18",
     f: 19,
     t: [-9.6,-22.55],
     m: [[0.66,0.75,-0.75,0.66,34.45,17.15],[0.99,0.12,-0.12,0.99,-3.85,39.95]]
    }
   },
   r: {
    n: "sprite33",
    t: [-20.12,12.4],
    v: {
     n: "sprite32",
     f: 19,
     t: [-4.15,-9.8],
     m: [[0.96,0.27,-0.27,0.96,18,28.7],[0.87,-0.5,0.5,0.87,-11.65,63.45]]
    }
   }
  }
 },
 wing029: {
  s: {
   t: [-15.66,56.23],
   z: [132.81,103.58],
   p: [
    {
     n: "sprite4",
     f: 20,
     m: [-0.8,0,0,1,44.15,98.45],
     t: [-8.95,-42.22]
    },
    {
     n: "sprite4",
     f: 20,
     m: [1,0,0,1,42.4,101],
     t: [-8.95,-42.22]
    }]
  },
  g: {
   l: {
    n: "sprite19",
    t: [-29.56,-4.9],
    v: {
     n: "sprite18",
     f: 19,
     t: [-9.6,-22.55],
     m: [[0.66,0.75,-0.75,0.66,34.45,17.15],[0.99,0.12,-0.12,0.99,-3.85,39.95]]
    }
   },
   r: {
    n: "sprite33",
    t: [-20.12,12.4],
    v: {
     n: "sprite32",
     f: 19,
     t: [-4.15,-9.8],
     m: [[0.96,0.27,-0.27,0.96,18,28.7],[0.87,-0.5,0.5,0.87,-11.65,63.45]]
    }
   }
  }
 },
 wing030: {
  s: {
   t: [-33.57,28.83],
   z: [175.87,124.37],
   p: [
    {
     n: "sprite3",
     f: 20,
     m: [1,0,0,1,45.15,102.05],
     t: [-16,-73.12]
    },
    {
     n: "sprite3",
     f: 20,
     m: [-0.8,0,0,1,44.15,101.95],
     t: [-16,-73.12]
    }]
  },
  g: {
   l: {
    n: "sprite18",
    t: [-49.83,8.74],
    v: {
     n: "sprite17",
     f: 19,
     t: [-18.05,-15],
     m: [[0.88,0.47,-0.47,0.88,21.15,30.45],[0.84,-0.54,0.54,0.84,-26.55,60.1]]
    }
   },
   r: {
    n: "sprite32",
    t: [-37.85,27.93],
    v: {
     n: "sprite31",
     f: 19,
     t: [0,0],
     m: [[0.98,0.16,-0.16,0.98,-6.75,28.35],[0.82,-0.57,0.57,0.82,-37.85,72.1]]
    }
   }
  }
 },
 wing043: {
  s: {
   t: [-49.9,-4.4],
   z: [204.8,204.8],
   p: [
    {
     n: "sprite25",
     f: 30,
     m: [0.8,0,0,0.8,52.5,106],
     t: [-128,-138]
    }]
  }
 },
 wing31: {
  s: {
   t: [-25.7,27.44],
   z: [158.03,105.28],
   p: [
    {
     n: "sprite47",
     f: 20,
     m: [0.82,0,0,0.82,10.6,19.15],
     t: [35.7,10.54]
    },
    {
     n: "sprite47",
     f: 20,
     m: [-0.66,-0.04,-0.05,0.77,78.4,25.3],
     t: [35.7,10.54]
    }]
  },
  g: {
   l: {
    n: "sprite72",
    t: [-31.37,14.94],
    v: {
     n: "sprite70",
     f: 19,
     t: [-51.31,-40.27],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,23.9,57.75]]
    }
   },
   r: {
    n: "sprite98",
    t: [-37.69,7.03],
    v: {
     n: "sprite96",
     f: 19,
     t: [-50.77,-51.47],
     m: [[1,0,0,1,46.35,58.5],[1,0,0,1,21.6,66.8]]
    }
   }
  }
 },
 wing32: {
  s: {
   t: [-25.7,27.44],
   z: [158.03,105.28],
   p: [
    {
     n: "sprite47",
     f: 20,
     m: [0.82,0,0,0.82,10.6,19.15],
     t: [35.7,10.54]
    },
    {
     n: "sprite47",
     f: 20,
     m: [-0.66,-0.04,-0.05,0.77,78.4,25.3],
     t: [35.7,10.54]
    }]
  },
  g: {
   l: {
    n: "sprite72",
    t: [-31.37,14.94],
    v: {
     n: "sprite70",
     f: 19,
     t: [-51.31,-40.27],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,23.9,57.75]]
    }
   },
   r: {
    n: "sprite98",
    t: [-37.69,7.03],
    v: {
     n: "sprite96",
     f: 19,
     t: [-50.77,-51.47],
     m: [[1,0,0,1,46.35,58.5],[1,0,0,1,21.6,66.8]]
    }
   }
  }
 },
 wing33: {
  s: {
   t: [-25.7,27.44],
   z: [158.03,105.28],
   p: [
    {
     n: "sprite47",
     f: 20,
     m: [0.82,0,0,0.82,10.6,19.15],
     t: [35.7,10.54]
    },
    {
     n: "sprite47",
     f: 20,
     m: [-0.66,-0.04,-0.05,0.77,78.4,25.3],
     t: [35.7,10.54]
    }]
  },
  g: {
   l: {
    n: "sprite72",
    t: [-31.37,14.94],
    v: {
     n: "sprite70",
     f: 19,
     t: [-51.31,-40.27],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,23.9,57.75]]
    }
   },
   r: {
    n: "sprite98",
    t: [-37.69,7.03],
    v: {
     n: "sprite96",
     f: 19,
     t: [-50.77,-51.47],
     m: [[1,0,0,1,46.35,58.5],[1,0,0,1,21.6,66.8]]
    }
   }
  }
 },
 wing34: {
  s: {
   t: [-25.7,27.44],
   z: [158.03,105.28],
   p: [
    {
     n: "sprite47",
     f: 20,
     m: [0.82,0,0,0.82,10.6,19.15],
     t: [35.7,10.54]
    },
    {
     n: "sprite47",
     f: 20,
     m: [-0.66,-0.04,-0.05,0.77,78.4,25.3],
     t: [35.7,10.54]
    }]
  },
  g: {
   l: {
    n: "sprite72",
    t: [-31.37,14.94],
    v: {
     n: "sprite70",
     f: 19,
     t: [-51.31,-40.27],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,23.9,57.75]]
    }
   },
   r: {
    n: "sprite98",
    t: [-37.69,7.03],
    v: {
     n: "sprite96",
     f: 19,
     t: [-50.77,-51.47],
     m: [[1,0,0,1,46.35,58.5],[1,0,0,1,21.6,66.8]]
    }
   }
  }
 },
 wing35: {
  s: {
   t: [-27.11,-16.64],
   z: [166.26,169.57],
   p: [
    {
     n: "sprite42",
     f: 45,
     m: [0.53,-0.14,0.14,0.53,-8.5,47.7],
     t: [-18.77,-60.34]
    }]
  },
  g: {
   l: {
    n: "sprite47",
    t: [10.1,45.75],
    v: {
     n: "sprite45",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,23.9,57.75]]
    }
   },
   r: {
    n: "sprite103",
    t: [-58.13,-37.68],
    v: {
     n: "sprite97",
     f: 35,
     t: [-74.41,-94.33],
     m: [[1,0,0,1,46.35,58.5],[0.41,-0.13,0.13,0.41,-29.35,22.05]]
    }
   }
  }
 },
 wing36: {
  s: {
   t: [-22.04,-47.41],
   z: [180.11,186.54],
   p: [
    {
     n: "sprite70",
     f: 501,
     m: [-1,0,0,1,79.6,56.05],
     t: [-78.47,-103.46]
    }]
  },
  g: {
   l: {
    n: "sprite85",
    t: [-33.52,-57.66],
    v: {
     n: "sprite73",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1.05,0,0,1.05,25.3,13.25]]
    }
   },
   r: {
    n: "sprite99",
    t: [-22.78,-64.54],
    v: {
     n: "sprite98",
     f: 14,
     t: [-77.63,-133.04],
     m: [[1,0,0,1,54.85,68.5],[1,0,0,1,43.3,59.45]]
    }
   }
  }
 },
 wing37: {
  s: {
   t: [-21.29,-75.8],
   z: [177.27,222.29],
   p: [
    {
     n: "sprite180",
     f: 875,
     m: [-1,0,0,1,79.6,56.05],
     t: [-76.38,-131.85]
    }]
  },
  g: {
   l: {
    n: "sprite184",
    t: [15.5,45.95],
    v: {
     n: "sprite183",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite194",
    t: [-44.68,-58.34],
    v: {
     n: "sprite186",
     f: 1,
     t: [-12.66,-13.5],
     m: [[1,0,0,1,-1.3,-11.05],[0.78,0,0,0.78,-6.25,-18.05],[0.78,0,0,0.78,-6.2,-17.85],[0.78,0,0,0.78,-5.45,-17.4],[0.78,0,0,0.78,-4.55,-28.1]]
    }
   }
  }
 },
 wing38: {
  s: {
   t: [-44.82,4.45],
   z: [209.06,160.03],
   p: [
    {
     n: "sprite52",
     f: 618,
     m: [-1,0,0,1,79.6,56.05],
     t: [-84.64,-51.6]
    }]
  },
  g: {
   l: {
    n: "sprite56",
    t: [15.5,45.95],
    v: {
     n: "sprite55",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite81",
    t: [-46.46,-15.95],
    v: {
     n: "sprite57",
     f: 329,
     t: [-6.37,-61.4],
     m: [[0.64,0,0,0.64,-38.2,23.35],[0.64,0,0,0.64,-28.8,44.6],[0.64,0,0,0.64,5.6,87.5],[0.64,0,0,0.64,-38.2,22.8],[0.64,0,0,0.64,8.35,87]]
    }
   }
  }
 },
 wing39: {
  s: {
   t: [-74.76,-135.19],
   z: [305.67,283.27],
   p: [
    {
     n: "sprite130",
     f: 765,
     m: [-1,0,0,1,79.6,56.05],
     t: [-151.31,-191.24]
    }]
  },
  g: {
   l: {
    n: "sprite134",
    t: [15.5,45.95],
    v: {
     n: "sprite133",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite142",
    t: [-75.74,-51.26],
    v: {
     n: "sprite135",
     f: 360,
     t: [-25.79,-27.38],
     m: [[1.02,0,0,1.02,-46,6.1],[0.64,0,0,0.64,-27.3,31.6],[0.29,0,0,0.29,-49.35,-26.75],[0.29,0,0,0.29,-49.05,-27.65],[1,0,0,1,65.6,34.3]]
    }
   }
  }
 },
 wing40: {
  s: {
   t: [-116.07,-85.35],
   z: [359.42,227.47],
   p: [
    {
     n: "sprite94",
     f: 765,
     m: [-1,0,0,1,79.6,56.05],
     t: [-163.74,-141.4]
    }]
  },
  g: {
   l: {
    n: "sprite98",
    t: [15.5,45.95],
    v: {
     n: "sprite97",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite106",
    t: [-93,-58.05],
    v: {
     n: "sprite100",
     f: 117,
     t: [-2.84,-5.6],
     m: [[1,0,0,1,-30.15,-20],[-1,-0.01,-0.01,1,51.5,-22.55],[0.78,0,0,0.78,-20.95,-22.95],[1,0,0,1,52.45,-20.75],[0.79,0.12,-0.12,0.79,-29.3,-19.55]]
    }
   }
  }
 },
 wing41: {
  s: {
   t: [-37.65,-84.95],
   z: [253.01,259.17],
   p: [
    {
     n: "sprite71",
     f: 765,
     m: [-1,0,0,1,79.6,56.05],
     t: [-135.76,-141]
    }]
  },
  g: {
   l: {
    n: "sprite75",
    t: [15.5,45.95],
    v: {
     n: "sprite74",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite88",
    t: [-79.41,-90.8],
    v: {
     n: "sprite77",
     f: 1,
     t: [-55.28,-63],
     m: [[1,0,0,1,14.05,52.95],[1,0,0,1,-17.2,7.3],[1,0,0,1,8.2,-11.6],[1,0,0,1,45.95,56.25],[1,0,0,1,-11.6,-15.3]]
    }
   }
  }
 },
 wing42: {
  s: {
   t: [-86.01,-122.23],
   z: [278.31,287.32],
   p: [
    {
     n: "sprite108",
     f: 795,
     m: [-1,0,0,1,79.6,56.05],
     t: [-112.69,-178.28]
    }]
  },
  g: {
   l: {
    n: "sprite112",
    t: [15.5,45.95],
    v: {
     n: "sprite111",
     f: 19,
     t: [-27.8,-13.5],
     m: [[1,0,0,1,43.3,59.45],[1,0,0,1,43.3,59.45]]
    }
   },
   r: {
    n: "sprite140",
    t: [-53.07,-110.81],
    v: {
     n: "sprite113",
     f: 1,
     t: [-25.27,-115.01],
     m: [[1,0,0,1,-27.8,4.2],[0.92,0,0,0.92,165.5,113.3],[0.92,0,0,0.92,44.25,21.85],[0.92,0,0,0.92,165.5,113.3],[0.92,0,0,0.92,66.65,-17.6]]
    }
   }
  }
 }
};
